"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheContractorsProblem() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section id="the-contractors-problem" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-10 tracking-tight">
            Why Do Electrical Contractors Use Evermark?
          </h2>

          <div className="space-y-8 border-l-2 border-primary/40 pl-6 md:pl-8">
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-sans">
              Electrical contractors order labeling under pressure: the panel is
              wired, the inspection is scheduled, and the legend plates,
              nameplates, and arc flash labels still have to be engraved,
              approved, and installed. A slow vendor or a wrong proof turns into
              a callback or a failed inspection.
            </p>
            
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-sans">
              Evermark Industrial Solutions is built for that reality.
              Contractors upload a panel layout or a legend list, get a fast
              quote with a real lead time, and approve a proof before anything
              is engraved — so the plates that arrive match the panel and the
              schedule. Rush options are available when the deadline is tight.
            </p>
            
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-sans">
              Evermark engraves the full set a contractor needs from one source
              — legend plates, panel nameplates, panel schedules, pushbutton
              plates, and arc flash labels — in phenolic, acrylic, stainless,
              aluminum, or brass, so a job doesn't get split across vendors.
            </p>
          </div>
        </div>
      </div>
    </section>;
}